module.exports = __webpack_public_path__ + "04_veryshort_brown.97319496.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_veryshort_brown.png
// module id = l0Wq
// module chunks = 0